import type { IconProps } from './types';

export const TextFormatIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M20.7552 13.7201C21.0481 13.4273 21.5229 13.4273 21.8158 13.7201C22.1086 14.0131 22.1086 14.4878 21.8158 14.7807L19.3109 17.2846L21.8158 19.7826C22.109 20.0752 22.1093 20.5509 21.8168 20.8442C21.5243 21.1372 21.0494 21.1375 20.7562 20.8451L18.2504 18.3451L15.7445 20.852C15.4516 21.1447 14.9768 21.1447 14.684 20.852C14.3911 20.5591 14.3912 20.0843 14.684 19.7914L17.1888 17.2856L14.6849 14.7875C14.3917 14.495 14.3905 14.0202 14.683 13.727C14.9755 13.4338 15.4503 13.4336 15.7435 13.726L18.2494 16.225L20.7552 13.7201ZM13.3929 6.57171V4.46429H9.17908V15.8217H10.5717L10.6478 15.8256C11.0262 15.8639 11.3217 16.1833 11.3217 16.5717C11.3215 16.96 11.0261 17.2796 10.6478 17.3178L10.5717 17.3217H6.28552C5.87151 17.3216 5.53567 16.9857 5.53552 16.5717C5.53552 16.1576 5.87142 15.8218 6.28552 15.8217H7.67908V4.46429H3.46423V6.57171C3.46408 6.98579 3.12835 7.32171 2.71423 7.32171C2.30011 7.32171 1.96438 6.98579 1.96423 6.57171V3.71429L1.96814 3.63714C2.00676 3.25917 2.32607 2.96429 2.71423 2.96429H14.1429L14.2191 2.96819C14.5975 3.00643 14.8929 3.32584 14.8929 3.71429V6.57171C14.8928 6.98575 14.557 7.32163 14.1429 7.32171C13.7288 7.32171 13.3931 6.98579 13.3929 6.57171Z"
        fill={color}
      />
    </svg>
  );
};
